export const embeddedTranslations: Record<string, Record<string, string>> = {
  en: {
    // Common
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.update": "Update",
    "common.loading": "Loading...",
    "common.success": "Success",
    "common.error": "Error",
    "common.confirm_delete": "Are you sure you want to delete this?",
    "common.name": "Name",
    "common.description": "Description",
    "common.price": "Price",
    "common.image": "Image",
    "common.status": "Status",
    "common.active": "Active",
    "common.inactive": "Inactive",
    "common.enabled": "Enabled",
    "common.disabled": "Disabled",
    "common.actions": "Actions",
    "common.date": "Date",
    "common.view": "View",
    "common.print": "Print",
    "common.copy": "Copy",
    "common.copied": "Copied",
    "common.download": "Download",
    "common.search": "Search",
    "common.filter": "Filter",
    "common.sort": "Sort",
    "common.save_changes": "Save Changes",
    "common.back": "Back",
    "common.required": "Required",
    "common.optional": "Optional",
    "common.email": "Email",
    "common.phone": "Phone",
    "common.address": "Address",
    "common.city": "City",
    "common.notes": "Notes",
    "common.total": "Total",
    "common.quantity": "Quantity",
    "common.login_required": "Please login again",
    "common.yes": "Yes",
    "common.no": "No",
    "common.retry": "Retry",
    "common.export_csv": "Export CSV",
    "common.all": "All",
    "common.from": "From",
    "common.to": "To",
    "common.reset": "Reset",
    "common.preview": "Preview",
    "common.upgrade": "Upgrade",
    "common.close": "Close",
    "common.confirm": "Confirm",
    "common.not_specified": "Not specified",
    "common.free": "Free",
    "common.load_error": "Error loading data",
    "common.save_error": "Error saving",
    "common.delete_error": "Error deleting",
    "common.update_error": "Error updating",
    "common.save_success": "Saved successfully",
    "common.delete_success": "Deleted successfully",
    "common.update_success": "Updated successfully",
    "common.no_sort": "No sorting",
    "common.clear": "Clear",
    "common.results": "results",
    "common.page": "page",
    "common.of": "of",

    // Orders
    "orders.title": "Orders",
    "orders.subtitle": "Manage and track customer orders",
    "orders.pending": "Pending",
    "orders.preparing": "Preparing",
    "orders.ready": "Ready",
    "orders.out_for_delivery": "Out for Delivery",
    "orders.delivered": "Delivered",
    "orders.cancelled": "Cancelled",
    "orders.completed": "Completed",
    "orders.type.dine_in": "Dine In",
    "orders.type.pickup": "Pickup",
    "orders.type.delivery": "Delivery",
    "orders.load_more": "Load More",
    "orders.refresh": "Refresh",
    "orders.order_number": "Order #",
    "orders.customer": "Customer",
    "orders.items": "Items",
    "orders.payment_status": "Payment Status",
    "orders.update_status": "Update Status",
    "orders.waiter": "Waiter",
    "orders.table": "Table",
    "orders.delivery_fee": "Delivery Fee",
    "orders.print_receipt": "Print Receipt",
    "orders.no_orders": "No orders found",
    "orders.auto_complete": "Auto-complete in",
    "orders.minutes": "min",
    "orders.today_stats": "Today's Stats",
    "orders.revenue": "Revenue",
    "orders.orders_count": "Orders Count",
    "orders.active_tab": "Active",
    "orders.completed_tab": "Completed",
    "orders.order_info": "Order Information",
    "orders.customer_info": "Customer Information",
    "orders.products": "Products",
    "orders.product": "Product",
    "orders.qty": "Qty",
    "orders.subtotal": "Subtotal",
    "orders.delivery_address": "Delivery Address",
    "orders.tracking": "Track",
    "orders.track_order": "Track Order",
    "orders.accept": "Prepare",
    "orders.mark_ready": "Ready",
    "orders.send_delivery": "Out for Delivery",
    "orders.mark_delivered": "Delivered",
    "orders.confirm_delivery": "Delivered",
    "orders.note": "Note",
    "orders.addons": "Add-ons",
    "orders.will_complete_soon": "Will complete soon",
    "orders.hours": "hour",
    "orders.and": "and",
    "orders.minutes_remaining": "minutes remaining",
    "orders.until_auto_complete": "until auto-complete",
    "orders.status_updated": "Order status updated",
    "orders.orders_refreshed": "Orders refreshed",
    "orders.allow_popups": "Please allow popups for printing",
    "orders.oldest_first": "Oldest first",
    "orders.newest_first": "Newest first",
    "orders.highest_amount": "Highest amount",
    "orders.lowest_amount": "Lowest amount",
    "orders.today": "Today",
    "orders.this_week": "This Week",
    "orders.this_month": "This Month",
    "orders.last_month": "Last Month",
    "orders.load_more_orders": "Load more orders",
    "orders.thank_you": "Thank you",
    "orders.branch": "Branch",
    "orders.unknown_branch": "Unknown branch",
    "orders.load_error": "Error loading orders",
    "orders.load_items_error": "Error loading order items",
    "orders.update_error": "Error updating status",
    "orders.source.pickup": "Pickup",
    "orders.source.delivery": "Delivery",
    "orders.source.waiter": "Waiter",
    "orders.source.cashier": "Cashier",
    "orders.edit_items": "Edit Order Items",
    "orders.notify_cashier": "Notify Cashier",
    "orders.notify_cashier_title": "Notify Cashier – Order #",
    "orders.notify_cashier_desc": "Describe the issue with this order. The cashier will see an alert.",
    "orders.notify_cashier_placeholder": "Example: Customer wants to cancel the order...",

    // Theme
    "theme.title": "Theme & Colors",
    "theme.subtitle": "Customize your digital menu appearance",
    "theme.primary_color": "Primary Color",
    "theme.secondary_color": "Secondary Color",
    "theme.background_color": "Background Color",
    "theme.text_color": "Text Color",
    "theme.preview": "Menu Preview",
    "theme.preview_desc": "How the menu will look to customers",
    "theme.logo": "Logo",
    "theme.cover_image": "Cover Image",
    "theme.banners": "Banner Ads",
    "theme.banner_hint": "Recommended size: 1200×300 px (4:1 landscape ratio) — JPG, PNG or WebP",
    "theme.banner_1": "Banner 1 (Top)",
    "theme.banner_2": "Banner 2 (Bottom)",
    "theme.save_success": "Theme saved successfully",
    "theme.banners_saved": "Banners saved successfully",
    "theme.colors": "Colors",
    "theme.colors_desc": "Choose your digital menu colors",
    "theme.colors_note": "These colors will be applied to all branches uniformly.",
    "theme.colors_saved": "Colors saved for all branches successfully",
    "theme.open": "Open",
    "theme.restaurant_name": "Restaurant Name",

    // QR Code
    "qr.title": "QR Code",
    "qr.subtitle": "Create and customize your menu QR code",
    "qr.customize": "Customize QR Code",
    "qr.preview": "QR Code Preview",
    "qr.download_png": "Download PNG",
    "qr.copy_link": "Copy Link",
    "qr.link_copied": "Link copied",
    "qr.downloaded": "QR Code downloaded successfully",
    "qr.color": "QR Color",
    "qr.bg_color": "Background Color",
    "qr.style": "Style",
    "qr.style.squares": "Squares",
    "qr.style.dots": "Dots",
    "qr.style.rounded": "Rounded",
    "qr.size": "Size",
    "qr.size_label": "QR Size",
    "qr.small": "Small",
    "qr.large": "Large",
    "qr.logo_center": "Add Logo in Center",
    "qr.use_restaurant_logo": "Use Restaurant Logo",
    "qr.menu_link": "Menu Link",
    "qr.menu_link_label": "Menu link:",
    "qr.no_link": "Link not set",
    "qr.reset_settings": "Default settings restored",
    "qr.preset_colors": "Preset Colors",
    "qr.custom_colors": "Custom Colors",
    "qr.dot_shape": "Dot Shape",
    "qr.colors_tab": "Colors",
    "qr.style_tab": "Style",
    "qr.logo_tab": "Logo",
    "qr.custom_logo": "Custom Logo",
    "qr.upload_logo": "Upload Custom Logo",
    "qr.remove_logo": "Remove Logo",
    "qr.logo_locked": "QR Logo Customization",
    "qr.logo_locked_desc": "Upgrade your plan to add your own logo to QR codes",
    "common.click_to_change": "Click to change image",
    "common.tip_square_logo": "Tip: Use a square image with a white background for the best result",
    "common.in_search": "in search engines",

    // Tables
    "tables.title": "Tables",
    "tables.subtitle": "Manage restaurant tables",
    "tables.add_new": "New Table",
    "tables.edit": "Edit Table",
    "tables.number": "Table Number",
    "tables.capacity": "Capacity",
    "tables.capacity_persons": "persons",
    "tables.status": "Status",
    "tables.status.available": "Available",
    "tables.status.occupied": "Occupied",
    "tables.status.reserved": "Reserved",
    "tables.delete_success": "Table deleted successfully",
    "tables.save_success": "Table saved successfully",
    "tables.update_success": "Table updated successfully",
    "tables.add_success": "Table added successfully",
    "tables.list": "Tables List",
    "tables.no_tables": "No tables found",
    "tables.capacity_label": "Capacity (persons)",
    "tables.placeholder": "e.g. A1",

    // Waiters
    "waiters.title": "Waiters",
    "waiters.subtitle": "Manage waiters and dine-in links",
    "waiters.add_new": "New Waiter",
    "waiters.edit": "Edit Waiter",
    "waiters.name": "Waiter Name",
    "waiters.code": "Code",
    "waiters.pin": "PIN Code",
    "waiters.pin_hint": "4-6 digits PIN required when opening the link",
    "waiters.photo": "Waiter Photo",
    "waiters.photo_optional": "Waiter Photo (optional)",
    "waiters.active": "Active",
    "waiters.copy_link": "Copy Link",
    "waiters.link_copied": "Waiter link copied",
    "waiters.list": "Waiters List",
    "waiters.no_waiters": "No waiters added",
    "waiters.no_waiters_hint": "Add a waiter to create a dine-in order link",
    "waiters.stats": "Analytics",
    "waiters.total_orders": "Total Orders",
    "waiters.total_revenue": "Total Revenue",
    "waiters.active_waiters": "Active",
    "waiters.inactive_waiters": "Inactive",
    "waiters.top_performance": "Top Performance",
    "waiters.waiter_mode": "Waiter Mode",
    "waiters.tab_waiters": "Waiters",
    "waiters.tab_analytics": "Analytics",
    "waiters.pin_enabled": "PIN Enabled",
    "waiters.activated": "Waiter activated",
    "waiters.deactivated": "Waiter deactivated",
    "waiters.add_success": "Waiter added successfully",
    "waiters.update_success": "Waiter updated successfully",
    "waiters.delete_success": "Waiter deleted successfully",
    "waiters.delete_confirm": "Are you sure you want to delete this waiter?",
    "waiters.placeholder": "e.g. Ahmed",
    "waiters.pin_placeholder": "e.g. 1234",
    "waiters.save_error": "Error saving waiter",
    "waiters.load_error": "Error loading waiters",

    // Delivery
    "delivery.title": "Delivery Settings",
    "delivery.subtitle": "Manage order types and delivery zones",
    "delivery.zones": "Delivery Zones",
    "delivery.add_zone": "New Zone",
    "delivery.edit_zone": "Edit Zone",
    "delivery.zone_name": "Zone Name",
    "delivery.zone_name_en": "Zone Name (EN)",
    "delivery.minimum_order": "Minimum Order",
    "delivery.estimated_time": "Estimated Time",
    "delivery.free_delivery": "Free Delivery",
    "delivery.free_delivery_desc": "Enable free delivery for all zones",
    "delivery.free_delivery_min": "Free delivery minimum order",
    "delivery.order_types": "Order Types",
    "delivery.type_delivery": "Delivery",
    "delivery.type_delivery_desc": "Customers can order delivery to their address",
    "delivery.type_pickup": "Pickup",
    "delivery.type_pickup_desc": "Customers can pick up their orders from the restaurant",
    "delivery.type_dine_in": "Dine In (Waiter Mode)",
    "delivery.type_dine_in_desc": "Orders through waiter links inside the restaurant",
    "delivery.enable_orders": "Orders Enabled",
    "delivery.view_only": "View Only Mode",
    "delivery.orders_enabled_desc": "Accept and manage customer orders through the menu",
    "delivery.view_only_desc": "Menu is for viewing only, ordering disabled",
    "delivery.order_settings": "Order Settings",
    "delivery.order_settings_desc": "Control available order types on the public menu",
    "delivery.zone_list": "Zones List",
    "delivery.no_zones": "No delivery zones added",
    "delivery.no_zones_hint": "Add a delivery zone to activate delivery service",
    "delivery.fee": "Delivery Fee",
    "delivery.min_order": "Min Order",
    "delivery.time": "Estimated Time",
    "delivery.add_success": "Zone added successfully",
    "delivery.update_success": "Zone updated successfully",
    "delivery.delete_success": "Zone deleted successfully",
    "delivery.delete_confirm": "Are you sure you want to delete this zone?",
    "delivery.settings_updated": "Settings updated successfully",
    "delivery.free_delivery_enabled": "Free delivery enabled",
    "delivery.free_delivery_disabled": "Free delivery disabled",
    "delivery.free_delivery_min_updated": "Free delivery minimum updated",
    "delivery.free_delivery_max_discount": "Maximum delivery discount",
    "delivery.upgrade_needed": "Not available in your plan - upgrade to enable this feature",
    "delivery.locked_feature": "Locked Feature",
    "delivery.upgrade_plan": "Upgrade",
    "delivery.time_placeholder": "e.g. 30-45 minutes",
    "delivery.zone_placeholder": "e.g. Downtown",

    // Branches
    "branches.title": "Branches",
    "branches.subtitle": "Manage restaurant branches",
    "branches.add_new": "Add Branch",
    "branches.edit": "Edit Branch",
    "branches.name": "Branch Name",
    "branches.name_required": "Branch name is required",
    "branches.slug": "Slug",
    "branches.main": "Main",
    "branches.set_main": "Set as Main",
    "branches.delete_warning": "Cannot delete main branch",
    "branches.limit_reached": "Branch limit reached",
    "branches.upgrade_required": "Upgrade required to add more branches",
    "branches.frozen": "Frozen",
    "branches.frozen_by_plan": "Frozen by plan",
    "branches.multi_branch": "Multi-Branch Management",
    "branches.upgrade_for_branches": "Upgrade your plan to add multiple branches",
    "branches.upgrade_to_add": "Upgrade to add branches",
    "branches.add_success": "Branch added successfully",
    "branches.update_success": "Branch updated successfully",
    "branches.delete_success": "Branch deleted successfully",
    "branches.main_set": "Main branch set",
    "branches.cannot_disable_main": "Cannot disable main branch",
    "branches.city": "City",
    "branches.link": "Link",
    "branches.image": "Branch Image",
    "branches.address_phone_hint": 'Address and phone are managed from the "Restaurant Info" page for each branch',
    "branches.saving": "Saving...",
    "branches.save_edits": "Save Changes",
    "branches.add_branch": "Add Branch",
    "branches.deleting": "Deleting branch...",
    "branches.delete_confirm_title": "Delete Branch",
    "branches.delete_confirm_desc":
      "Are you sure you want to delete this branch? This action cannot be undone and will remove all related data.",
    "branches.plan_allows": "Your plan allows",
    "branches.branch_only": "branch only",
    "branches.branches_only": "branches only",
    "branches.frozen_branches": "frozen branches",
    "branches.frozen_branch": "frozen branch",
    "branches.max_reached": "You reached the maximum branches",
    "branches.upgrade_for_more": "Upgrade your plan to add more.",
    "branches.upgrade_to_activate": "Upgrade plan to activate this branch",

    // Reports
    "reports.title": "Reports",
    "reports.subtitle": "Detailed analytics for your restaurant",
    "reports.subtitle_long": "Detailed analytics for your restaurant — data fetched on demand only",
    "reports.customers": "Customers",
    "reports.products": "Products",
    "reports.branches": "Branches",
    "reports.summary_tab": "Summary",
    "reports.cashier": "Cashier",
    "reports.total_spent": "Total Spent",
    "reports.orders_count": "Orders",
    "reports.views": "Views",
    "reports.carts": "Added to Cart",
    "reports.no_data": "No data found",
    "reports.date.today": "Today",
    "reports.date.week": "This Week",
    "reports.date.month": "This Month",
    "reports.date.year": "This Year",
    "reports.customer_report": "Customer Report",
    "reports.customer_report_desc": "View customer names, phones, addresses, and order counts.",
    "reports.order_report": "Order Report",
    "reports.order_report_desc": "View all orders with details and statuses.",
    "reports.product_report": "Product Report",
    "reports.product_report_desc": "View product sales, quantities, and revenue.",
    "reports.waiter_report": "Waiter Report",
    "reports.waiter_report_desc": "View waiter performance, orders, and revenue.",
    "reports.branch_report": "Branch Comparison",
    "reports.branch_report_desc": "Compare performance across all branches.",
    "reports.load_report": "Load Report",
    "reports.sort_by": "Sort by",
    "reports.most_orders": "Most orders",
    "reports.highest_spending": "Highest spending",
    "reports.name_az": "Name (A-Z)",
    "reports.newest": "Newest",
    "reports.highest_amount": "Highest amount",
    "reports.most_sold": "Most sold",
    "reports.highest_revenue": "Highest revenue",
    "reports.most_revenue": "Most revenue",
    "reports.waiters": "Waiters",
    "reports.avg_order": "Avg Order",
    "reports.total_revenue": "Total Revenue",

    // Subscription
    "subscription.title": "Subscription",
    "subscription.subtitle": "Current plan and available packages",
    "subscription.current_plan": "Current Plan",
    "subscription.status": "Status",
    "subscription.expires_at": "Expires At",
    "subscription.renew": "Renew Subscription",
    "subscription.upgrade": "Upgrade Plan",
    "subscription.compare_plans": "Compare Plans",
    "subscription.billing_history": "Billing History",
    "subscription.invoice": "Invoice",
    "subscription.cancel": "Cancel Subscription",
    "subscription.active": "Active",
    "subscription.expired": "Expired",
    "subscription.suspended": "Suspended",
    "subscription.trial": "Trial",
    "subscription.days_left": "days left",
    "subscription.lifetime": "Lifetime",
    "subscription.monthly": "Monthly",
    "subscription.yearly": "Yearly",
    "subscription.contact_support": "Contact Support",
    "subscription.no_subscription": "No active subscription",
    "subscription.subscribe_now": "Subscribe Now",
    "subscription.available_plans": "Available Plans",
    "subscription.current": "Current",
    "subscription.usage": "Usage",
    "subscription.start_trial": "Start Free Trial",
    "subscription.trial_started": "Free trial started!",
    "subscription.cancel_confirm": "Cancel Subscription?",
    "subscription.cancel_desc": "Your subscription will remain active until the end of the current period.",
    "subscription.cancel_success": "Subscription cancelled. It will remain active until the end of the period.",
    "subscription.keep": "Keep Subscription",
    "subscription.confirm_cancel": "Yes, Cancel",
    "subscription.per_month": "/month",
    "subscription.per_year": "/year",
    "subscription.free_plan": "Free",

    // Trash
    "trash.title": "Trash",
    "trash.subtitle": "Deleted items will be removed permanently after 14 days",
    "trash.products": "Products",
    "trash.categories": "Categories",
    "trash.restore": "Restore",
    "trash.delete_forever": "Delete Forever",
    "trash.empty_trash": "Empty Trash",
    "trash.no_items": "Trash is empty",
    "trash.no_items_hint": "Deleted items will appear here",
    "trash.deleted_at": "Deleted at",
    "trash.expires_in": "Expires in",
    "trash.days": "days",
    "trash.will_delete_soon": "Will be deleted soon",
    "trash.permanently_after": "Will be permanently deleted after",
    "trash.deleted_products": "Deleted Products",
    "trash.deleted_categories": "Deleted Categories",
    "trash.no_products": "No deleted products",
    "trash.no_categories": "No deleted categories",
    "trash.restore_product_success": "Product restored successfully",
    "trash.restore_category_success": "Category restored successfully",
    "trash.delete_product_success": "Product permanently deleted",
    "trash.delete_category_success": "Category permanently deleted",
    "trash.empty_success": "Trash emptied",
    "trash.confirm_title": "Confirm Deletion",
    "trash.confirm_desc": "This action cannot be undone.",
    "trash.uncategorized": "Uncategorized",

    // Menu Extract
    "extract.title": "AI Menu Extraction",
    "extract.subtitle": "Upload menu images to automatically extract items",
    "extract.upload": "Upload Files",
    "extract.upload_title": "Upload Menu Images",
    "extract.upload_desc": "Upload images or PDF files (up to 10MB per file)",
    "extract.analyzing": "Analyzing...",
    "extract.review": "Review & Edit",
    "extract.migrating": "Migrating...",
    "extract.done": "Done",
    "extract.start": "Start Extraction",
    "extract.history": "History",
    "extract.history_title": "Previous Operations",
    "extract.no_history": "No previous operations",
    "extract.limit_reached": "Extraction limit reached",
    "extract.migrate_button": "Migrate to Menu",
    "extract.files_count": "files selected",
    "extract.drag_drop": "Drag & drop files here",
    "extract.take_photo": "Take Photo",
    "extract.ai_analysis": "AI Analysis",
    "extract.step_upload": "Upload Files",
    "extract.step_analyze": "AI Analysis",
    "extract.step_review": "Review & Edit",
    "extract.step_migrate": "Migrate to Menu",
    "extract.unsupported_type": "Unsupported type",
    "extract.file_too_large": "File too large",
    "extract.max_size": "Max 10MB",
    "extract.upload_images_pdf": "Please upload images or PDF",
    "extract.analysis_error": "Analysis error",
    "extract.migration_error": "Migration error",
    "extract.migration_success": "Migration successful! 🎉",
    "extract.products_created": "products created",
    "extract.categories_created": "categories created",
    "extract.new_product": "New Product",
    "extract.new_addon": "New Add-on",
    "extract.pages": "pages",
    "extract.completed": "Completed",
    "extract.failed": "Failed",
    "extract.processing": "Processing",
    "extract.extraction_ops": "extraction operations",
    "extract.unlimited": "unlimited",
    "extract.includes_bonus": "includes bonus credit",
    "extract.feature_disabled": "This feature is not available in your current plan",
    "extract.select_branch": "Select branch to migrate to",

    // Invoices & Billing
    "invoice.number": "Invoice #",
    "invoice.date": "Date",
    "invoice.to": "Bill To",
    "invoice.from": "From",
    "invoice.item": "Item",
    "invoice.amount": "Amount",
    "invoice.total": "Total",
    "invoice.status": "Status",
    "invoice.paid": "Paid",
    "invoice.failed": "Failed",
    "invoice.thank_you": "Thank you for your business",
    "billing.title": "Billing History",
    "billing.total_paid": "Total Paid",
    "billing.no_invoices": "No previous invoices",
    "billing.invoices_hint": "Your invoices will appear here after completing payments",
    "billing.invoice_number": "Invoice Number",
    "billing.plan": "Plan",
    "billing.payment_method": "Payment Method",
    "billing.view": "View",
    "billing.preview_invoice": "Preview Invoice",
    "billing.showing": "Showing",

    // Plan features & limits
    "plan.unlimited": "Unlimited",
    "plan.limits_capacity": "Limits & Capacity",
    "plan.features_services": "Features & Services",
    "plan.feature.has_orders": "Order Management",
    "plan.feature.has_orders_desc": "Receive customer orders directly through the menu",
    "plan.feature.has_pickup": "Pickup Service",
    "plan.feature.has_pickup_desc": "Customers can request pickup from the restaurant",
    "plan.feature.has_delivery": "Delivery Service",
    "plan.feature.has_delivery_desc": "Manage delivery zones and fees",
    "plan.feature.has_tables": "Waiter Mode",
    "plan.feature.has_tables_desc": "Custom QR codes and links per waiter for in-restaurant orders",
    "plan.feature.has_branches": "Multiple Branches",
    "plan.feature.has_branches_desc": "Add and manage multiple restaurant branches",
    "plan.feature.has_staff": "Staff Management",
    "plan.feature.has_staff_desc": "Add staff with different permissions",
    "plan.feature.has_category_scheduling": "Category Scheduling",
    "plan.feature.has_category_scheduling_desc": "Set specific display times for categories",
    "plan.feature.has_qr_customization": "QR Code Customization",
    "plan.feature.has_qr_customization_desc": "Design QR codes with custom colors and logo",
    "plan.feature.has_custom_theme": "Custom Theme",
    "plan.feature.has_custom_theme_desc": "Customize menu colors and fonts",
    "plan.feature.has_reports": "Advanced Reports",
    "plan.feature.has_reports_desc": "Detailed reports on customers, orders, products, and waiters",
    "plan.feature.remove_branding": "Remove Platform Branding",
    "plan.feature.remove_branding_desc": 'Remove "Powered by..." from the menu',
    "plan.feature.has_menu_extraction": "AI Menu Extraction",
    "plan.feature.has_menu_extraction_desc": "Automatically extract products from menu images",
    "plan.limit.max_products": "Products",
    "plan.limit.max_products_desc": "Maximum number of products in the menu",
    "plan.limit.max_categories": "Categories",
    "plan.limit.max_categories_desc": "Maximum number of menu categories",
    "plan.limit.max_staff": "Staff",
    "plan.limit.max_staff_desc": "Maximum number of staff members",
    "plan.limit.max_branches": "Branches",
    "plan.limit.max_branches_desc": "Maximum number of allowed branches",
    "plan.limit.max_menu_extractions": "Menu Extractions",
    "plan.limit.max_menu_extractions_desc": "Number of AI-powered menu extractions from images",
    "branches.name_en": "Branch Name (English)",

    // Orders extras
    "orders.loading": "Loading...",
    "orders.manage_subtitle": "Manage and track customer orders",
    "orders.customer_data": "Customer Info",
    "orders.delivery_data": "Delivery Info",
    "orders.zone": "Zone",
    "orders.delivery_fees": "Delivery Fee",
    "orders.free_delivery": "Free ✨",
    "orders.no_details": "No details",
    "orders.total_overall": "Grand Total",
    "orders.products_amount": "Products",
    "orders.delivery_amount": "Delivery",
    "orders.start_preparing": "Start Preparing",
    "orders.cancel_order": "Cancel",
    "orders.customer_default": "Customer",
    "orders.table_number": "Table",
    "orders.feature_name": "Order Management",
    "orders.feature_desc": "Receive and manage customer orders. Available in advanced plans.",

    // Reports extras (non-duplicates only)
    "reports.total_orders_label": "Total Orders",
    "reports.total_revenue_label": "Total Revenue",
    "reports.total_branches": "Total Branches",
    "reports.total_products": "Total Products",
    "reports.by_status": "By Status",
    "reports.by_type": "By Type",
    "reports.no_orders_period": "No orders in this period",
    "reports.no_branches": "No branches",
    "reports.phone": "Phone",
    "reports.total_spent_label": "Total Spent",
    "reports.customer_name": "Name",
    "reports.order_amount": "Amount",
    "reports.order_type": "Type",
    "reports.order_waiter": "Waiter",
    "reports.product_view": "View",
    "reports.product_cart": "Cart",
    "reports.product_order": "Order",
    "reports.revenue": "Revenue",
    "reports.main_branch": "Main",
    "reports.inactive_branch": "Inactive",
    "reports.product_count": "Product",
    "reports.category_count": "Category",
    "reports.staff_count": "Staff",
    "reports.table_count": "Table",
    "reports.active_waiter": "Active Waiter",
    "reports.locked_title": "Reports",
    "reports.locked_desc": "Detailed analytics for your restaurant",

    // Subscription extras
    "subscription.loading": "Loading...",
    "subscription.plan_details": "Current plan details and available packages",
    "subscription.trial_period": "Trial Period",
    "subscription.days_remaining": "days remaining",
    "subscription.ends_at": "Ends at",
    "subscription.products": "Products",
    "subscription.categories": "Categories",
    "subscription.staff": "Staff",
    "subscription.cancel_subscription": "Cancel Subscription",
    "subscription.cancel_stay_until": "You will remain subscribed until",
    "subscription.then_free": "then you will be moved to the free plan",
    "subscription.cancel_confirm_title": "Cancel Subscription",
    "subscription.cancel_confirm_desc":
      "Are you sure you want to cancel? You will keep all features until the end of the current period, then be moved to the free plan.",
    "subscription.go_back": "Go Back",
    "subscription.cancelling": "Cancelling...",
    "subscription.confirm_cancel_btn": "Confirm Cancellation",
    "subscription.compare_title": "Compare Plans",
    "subscription.compare_desc": "Compare plans and choose the best for you",
    "subscription.no_plans": "No plans available currently",
    "subscription.no_active": "No Active Subscription",
    "subscription.no_active_desc": "Choose a plan above or contact us to activate",
    "subscription.contact_us": "Contact Us",
    "subscription.need_help": "Need help?",
    "subscription.help_desc": "Contact us for any questions about subscriptions or plans",

    // Extract extras
    "extract.upload_files_label": "Upload Files",
    "extract.take_photo_label": "Take Photo",
    "extract.take_photo_desc": "Use camera to photograph the menu",
    "extract.files_attached": "files attached",
    "extract.start_analysis": "Start Analysis",
    "extract.analyzing_title": "Analyzing menu with AI...",
    "extract.analyzing_desc": "Reading images and extracting items and prices",
    "extract.category_label": "Category",
    "extract.product_label": "Product",
    "extract.addons_label": "Add-ons",
    "extract.addon_name": "Add-on name",
    "extract.add_addon": "Add",
    "extract.add_product": "Add Product",
    "extract.migrate_to_branch": "Migrate to branch",
    "extract.choose_branch": "Choose branch",
    "extract.main_branch": "Main",
    "extract.start_new": "Start New",
    "extract.migrate_products": "Migrate products to menu",
    "extract.confirm_migrate_title": "Confirm Migration to Menu",
    "extract.confirm_migrate_before": "Before migrating, please make sure:",
    "extract.confirm_names": "Product names are correct and properly written",
    "extract.confirm_prices": "Prices are accurate and match the original menu",
    "extract.confirm_categories": "Categories are organized and named correctly",
    "extract.confirm_images": "Product images have been added (can be added later too)",
    "extract.will_create": "Will create",
    "extract.products_in_menu": "products in the food menu",
    "extract.back_to_review": "Back to Review",
    "extract.confirm_migrate": "Confirm Migration",
    "extract.migrating_title": "Migrating data to the food menu...",
    "extract.migrating_desc": "Creating categories, products, and add-ons",
    "extract.success_title": "Migration successful! 🎉",
    "extract.success_desc": "Items have been added to the food menu",
    "extract.new_categories": "new categories",
    "extract.new_products": "new products",
    "extract.skipped": "duplicates skipped",
    "extract.addons_created": "add-ons",
    "extract.extract_another": "Extract Another Menu",
    "extract.view_menu": "View Menu",

    // Profile
    "profile.title": "Profile",
    "profile.manage": "Manage your account",
    "profile.photo": "Profile Photo",
    "profile.photo_desc": "Update your profile photo",
    "profile.click_camera": "Click the camera icon to change photo",
    "profile.prefer_square": "Square image is preferred",
    "profile.info": "Personal Information",
    "profile.info_desc": "Update your name and email",
    "profile.name": "Name",
    "profile.name_placeholder": "Enter your name",
    "profile.email": "Email",
    "profile.email_placeholder": "Enter your email",
    "profile.save": "Save Changes",
    "profile.updated": "Updated",
    "profile.updated_desc": "Profile updated successfully",
    "profile.photo_updated": "Profile photo updated successfully",
    "profile.change_password": "Change Password",
    "profile.change_password_desc": "Update your account password",
    "profile.current_password": "Current Password",
    "profile.current_password_placeholder": "Enter current password",
    "profile.new_password": "New Password",
    "profile.new_password_placeholder": "Enter new password",
    "profile.confirm_password": "Confirm New Password",
    "profile.confirm_password_placeholder": "Re-enter new password",
    "profile.password_mismatch": "New passwords do not match",
    "profile.password_short": "Password must be at least 6 characters",
    "profile.password_changed": "Password changed successfully",

    // Country Flag
    "country.select": "Select country flag",
    "country.search": "Search for a country...",

    // Currency
    "currency.select": "Select currency...",
    "currency.search": "Search for a currency...",
    "currency.not_found": "No currency found",
    "currency.gulf": "Gulf Countries",
    "currency.arab": "Arab Countries",
    "currency.major": "Major Currencies",
    "currency.asian": "Asian Currencies",
    "currency.african": "African Currencies",
    "currency.european": "European Currencies",
    "currency.americas": "Americas Currencies",
    "currency.crypto": "Cryptocurrencies",

    // SEO
    "seo.title": "SEO Settings",
    "seo.description": "Improve search engine visibility for",
    "seo.meta_title": "SEO Title (Meta Title)",
    "seo.meta_title_placeholder": "Title shown in search results",
    "seo.meta_title_hint": "Recommended: under 60 characters",
    "seo.meta_description": "SEO Description (Meta Description)",
    "seo.meta_description_placeholder": "Brief description shown in search results",
    "seo.meta_description_hint": "Recommended: under 160 characters",
    "seo.keywords": "Keywords",
    "seo.keywords_placeholder": "restaurant, food, delivery, ...",
    "seo.keywords_hint": "Separate keywords with commas",
    "seo.og_image": "Share Image (OG Image)",
    "seo.og_image_hint": "Image shown when sharing the link on social media • Ideal size: 1200x630px",
    "seo.preview": "Search results preview:",

    // Social Links
    "social.title": "Social Media Links",
    "social.description": "Add your social media account links",
    "social.facebook": "Facebook",
    "social.twitter": "Twitter / X",
    "social.instagram": "Instagram",
    "social.youtube": "YouTube",
    "social.tiktok": "TikTok",
    "social.linkedin": "LinkedIn",
    "social.whatsapp": "WhatsApp",
    "social.telegram": "Telegram",
    "social.snapchat": "Snapchat",

    // Menu Visits
    "menu_visits.title": "Menu Visits",
    "menu_visits.today": "Today",
    "menu_visits.period_total": "Period Total",
    "menu_visits.change": "Change",
    "menu_visits.no_data": "No visit data for this period",
    "menu_visits.7d": "7 Days",
    "menu_visits.30d": "30 Days",
    "menu_visits.month": "Month",
    "menu_visits.this_year": "This Year",
    "menu_visits.last_year": "Last Year",
    "menu_visits.all": "All",
    "menu_visits.main_page": "Main Page",
    "menu_visits.visits": "Visits",

    // Settings
    "settings.title": "Settings",
    "settings.general": "General",
    "settings.seo": "SEO",
    "settings.social": "Social",
    "settings.domain": "Domain",
    "settings.restaurant_name": "Restaurant Name",
    "settings.restaurant_slug": "Restaurant Slug",
    "settings.auto_complete": "Auto-complete Orders",
    "settings.auto_complete_desc": "Active orders will be automatically marked as \"completed\" after the specified time",
    "settings.one_hour": "1 hour",
    "settings.hours": "hours",
    "settings.auto_complete_waiter_note": "Note: Waiter orders (table orders) are not auto-completed and must be completed manually.",

    // Status page
    "status.title": "Restaurant Status",
    "status.subtitle": "Control restaurant status (open/closed) and working hours",
    "status.open": "Open",
    "status.closed": "Closed",
    "status.scheduled": "Scheduled",
    "status.working_hours": "Working Hours",
    "status.working_hours_desc": "Set working hours for each day of the week",
    "status.mode": "Status Mode",
    "status.mode_desc": "Choose how you want to control the restaurant status (open/closed)",
    "status.always_open": "Always Open",
    "status.always_open_desc": "Restaurant is open and accepting orders 24/7",
    "status.always_closed": "Always Closed",
    "status.always_closed_desc": "Restaurant is closed and not accepting orders",
    "status.schedule": "Schedule Based",
    "status.schedule_desc": "Status is automatically set based on defined working hours",
    "status.schedule_label": "Schedule",
    "status.saved": "Status settings saved successfully",
    "status.save": "Save Status Settings",
    "status.day_open": "Open",
    "status.day_closed": "Closed",
    "status.to": "to",

    // Onboarding
    "onboarding.welcome": "Welcome to Menu!",
    "onboarding.welcome_desc": "Let us help you set up your restaurant menu",
    "onboarding.step1_title": "Restaurant Info",
    "onboarding.step1_desc": "Add basic information",
    "onboarding.step2_title": "Colors & Appearance",
    "onboarding.step2_desc": "Choose your menu colors",
    "onboarding.step3_title": "First Category",
    "onboarding.step3_desc": "Create the first menu category",
    "onboarding.description": "Restaurant Description",
    "onboarding.description_placeholder": "Write a brief description of your restaurant...",
    "onboarding.phone": "Phone Number",
    "onboarding.address": "Address",
    "onboarding.address_placeholder": "Restaurant address",
    "onboarding.primary_color": "Primary Color",
    "onboarding.secondary_color": "Secondary Color",
    "onboarding.preview": "Color Preview:",
    "onboarding.primary": "Primary",
    "onboarding.secondary": "Secondary",
    "onboarding.category_name": "First Category Name",
    "onboarding.category_placeholder": "e.g. Hot Drinks",
    "onboarding.category_hint": "You can add more categories later from the dashboard",
    "onboarding.enter_category": "Please enter category name",
    "onboarding.theme_error": "Error saving colors",
    "onboarding.category_error": "Error creating category",
    "onboarding.setup_done": "Setup completed successfully!",
    "onboarding.skip": "Skip Setup",
    "onboarding.previous": "Previous",
    "onboarding.next": "Next",
    "onboarding.finish": "Finish Setup",

    // Billing & Invoice
    "billing.invoice_title": "Invoice",
    "billing.subscription_invoice": "Subscription Invoice",
    "billing.customer_info": "Customer Information",
    "billing.invoice_details": "Invoice Details",
    "billing.payment_method_label": "Payment Method",
    "billing.transaction_id": "Transaction ID",
    "billing.description_col": "Description",
    "billing.amount_col": "Amount",
    "billing.upgrade_to": "Upgrade to",
    "billing.subscription": "Subscription",
    "billing.upgrade_with_proration": "Plan upgrade with remaining value deduction",
    "billing.plan_subscription": "Plan subscription",
    "billing.remaining_value": "Remaining value from previous subscription",
    "billing.billing_cycle": "Billing Cycle",
    "billing.cycle_monthly": "Monthly",
    "billing.cycle_yearly": "Yearly",
    "billing.cycle_lifetime": "Lifetime",
    "billing.amount_due": "Amount Due",
    "billing.grand_total": "Total",
    "billing.status_paid": "✓ Paid",
    "billing.status_failed": "Failed",
    "billing.thank_you_msg": "Thank you for subscribing",
    "billing.platform_desc": "Restaurant Management Platform",
    "billing.card_payment": "Card Payment",

    // Dashboard / Overview
    "dashboard.title": "Dashboard",
    "dashboard.menu_visits": "Menu Visits",
    "dashboard.total_orders": "Total Orders",
    "dashboard.total_revenue": "Total Revenue",
    "dashboard.recent_orders": "Recent Orders",

    // FeatureGate
    "feature.waiter_mode": "Waiter Mode",
    "feature.waiter_mode_desc":
      "Create custom links and QR codes for each waiter to manage dine-in orders. Available in advanced plans.",

    // Menu page
    "menu.title": "Food Menu",
    "menu.subtitle": "Manage categories and products",
    "menu.view_menu": "View Menu",
    "menu.clone_from_main": "Clone menu from main branch",
    "menu.branch_empty": "This branch has no categories or products yet",
    "menu.cloning": "Cloning...",
    "menu.clone_success": "Menu cloned from main branch successfully",
    "menu.clone_error": "Error cloning menu",
    "menu.no_main_branch": "Main branch not found",
    "menu.no_main_categories": "No categories in main branch to clone",
    "menu.error_loading": "Error loading data",
    "menu.categories_and_products": "Categories & Products",
    "menu.category_count": "category",
    "menu.product_count": "product",
    "menu.new_category": "New Category",
    "menu.search_products": "Search products...",
    "menu.no_categories": "No categories",
    "menu.add_category": "Add Category",
    "menu.no_products": "No products",
    "menu.add_product": "Add Product",
    "menu.cannot_delete_has_products": "Cannot delete category with products",
    "menu.delete_category": "Delete Category",
    "menu.schedule": "Schedule",
    "menu.edit_schedule": "Edit",
    "menu.prep_time_short": "min",
    "menu.calories_short": "cal",
    "menu.walking_short": "min walk",
    "menu.limit_reached": "Limit reached",
    "menu.categories_label": "Categories",
    "menu.products_label": "Products",

    // Category form
    "category.edit_title": "Edit Category",
    "category.add_title": "Add New Category",
    "category.image": "Category Image",
    "category.name_ar": "Category Name (Arabic)",
    "category.name_en": "Category Name (English)",
    "category.desc_ar": "Description (Arabic)",
    "category.desc_en": "Description",
    "category.name_placeholder_ar": "e.g. Hot Beverages",
    "category.name_placeholder_en": "e.g. Hot Beverages",
    "category.desc_placeholder_ar": "Short category description...",
    "category.desc_placeholder_en": "Short category description...",
    "category.save_success": "Category saved successfully",
    "category.add_success": "Category added successfully",
    "category.save_error": "Error saving category",
    "category.delete_confirm": "Are you sure you want to delete this category? It will be moved to trash.",
    "category.delete_has_products": "Cannot delete a category that has products",
    "category.delete_success": "Category moved to trash",
    "category.delete_error": "Error deleting category",
    "category.toggle_error": "Error updating status",
    "category.schedule_success": "Category schedule saved successfully",
    "category.schedule_error": "Error saving schedule",

    // Category schedule
    "schedule.title": "Schedule Category",
    "schedule.enable": "Enable Scheduling",
    "schedule.enable_desc": "Show category only at specific times",
    "schedule.days": "Visible Days",
    "schedule.select_all": "Select All",
    "schedule.clear_all": "Clear All",
    "schedule.start_time": "Start Time",
    "schedule.end_time": "End Time",
    "schedule.preview": "This category will appear on:",
    "schedule.no_days": "no days selected",
    "schedule.all_days": "all days",
    "schedule.from": "from",
    "schedule.to": "to",
    "schedule.save": "Save Schedule",
    "schedule.day.sunday": "Sunday",
    "schedule.day.monday": "Monday",
    "schedule.day.tuesday": "Tuesday",
    "schedule.day.wednesday": "Wednesday",
    "schedule.day.thursday": "Thursday",
    "schedule.day.friday": "Friday",
    "schedule.day.saturday": "Saturday",

    // Product form
    "product.edit_title": "Edit Product",
    "product.add_title": "Add New Item",
    "product.details_tab": "Item Details",
    "product.addons_tab": "Add-ons & Options",
    "product.name_ar": "Product Name",
    "product.name_en": "Product Name",
    "product.name_placeholder_ar": "e.g. Arabic Coffee",
    "product.name_placeholder_en": "e.g. Arabic Coffee",
    "product.category": "Category",
    "product.category_placeholder": "Select category",
    "product.desc_ar": "Description",
    "product.desc_en": "Description",
    "product.desc_placeholder_ar": "Short product description...",
    "product.desc_placeholder_en": "Short product description...",
    "product.price": "Price",
    "product.image": "Product Image",
    "product.extra_info": "Additional Info (optional)",
    "product.prep_time": "Prep Time (min)",
    "product.calories": "Calories (100g)",
    "product.walking_minutes": "Walk to burn (min)",
    "product.required_fields": "Please fill all required fields",
    "product.save_success": "Product saved successfully",
    "product.add_success": "Product added successfully",
    "product.save_error": "Error saving product",
    "product.save_changes": "Save Changes",
    "product.delete_confirm": "Are you sure you want to delete this product? It will be moved to trash.",
    "product.delete_success": "Product moved to trash",
    "product.delete_error": "Error deleting product",
    "product.badge": "Product Badge (optional)",
    "product.badge_type": "Badge Type",
    "product.badge_none": "None",
    "product.badge_best_seller": "Best Seller",
    "product.badge_new": "New",
    "product.badge_popular": "Popular",
    "product.badge_spicy": "Spicy",
    "product.badge_healthy": "Healthy",
    "product.badge_limited": "Limited Time",
    "product.badge_chef_pick": "Chef's Pick",
    "product.badge_vegan": "Vegan",
    "product.badge_discount": "Special Offer",
    "product.badge_love": "Most Loved",


    // Addons
    "addon.single_select": "Single Select",
    "addon.multi_select": "Multiple",
    "addon.required": "Required field",
    "addon.options": "Options",
    "addon.group_placeholder_ar": "Group name (Arabic)",
    "addon.group_placeholder_en": "Group name (English)",
    "addon.group_placeholder_single_ar": "Group name (e.g. Size, Extras)",
    "addon.group_placeholder_single_en": "Group name (e.g. Size, Extras)",
    "addon.option_placeholder_ar": "Option name (Arabic)",
    "addon.option_placeholder_en": "Option name (English)",
    "addon.option_placeholder_single_ar": "Option name",
    "addon.option_placeholder_single_en": "Option name",
    "addon.price_placeholder": "Price",
    "addon.price_label": "Addon Price",
    "addon.group_label": "Addon Group",

    // Image Upload
    "image.upload": "Upload Image",
    "image.unsplash_search": "Unsplash Search",
    "image.formats": "JPG, PNG, WebP - up to 5MB",
    "image.square_hint": "Square images are preferred",
    "image.change": "Change",
    "image.not_square": "Image is not square — click to crop",
    "image.uploaded": "Image Uploaded",
    "image.uploaded_desc": "Image compressed and uploaded successfully",
    "image.upload_error": "Upload Failed",
    "image.upload_error_desc": "An error occurred while uploading, please try again",
    "image.login_required": "You must be logged in to upload images",
    "image.upload_failed": "Image upload failed",
    "image.invalid_type": "Unsupported file type",
    "image.invalid_type_desc": "Please upload a JPG, PNG, WebP or GIF image",
    "image.too_large": "File too large",
    "image.too_large_desc": "Maximum image size is 5MB",
    "image.selected": "Image Selected",
    "image.selected_desc": "Image selected from Unsplash successfully",
    "addon.add_option": "Add Option",
    "addon.add_group": "Add New Group",

    // Reports extras - content labels
    "reports.order_count_label": "orders",
    "reports.phone_label": "Phone",
    "reports.total_spent_card": "Total Spent",
    "reports.address_label": "Address",
    "reports.order_report_title": "Order Report",
    "reports.order_report_full_desc": "View all orders with details, statuses, and time filters.",
    "reports.total_orders_summary": "Total Orders",
    "reports.total_revenue_summary": "Total Revenue",
    "reports.by_status_label": "By Status",
    "reports.by_type_label": "By Type",
    "reports.no_orders_in_period": "No orders in this period",
    "reports.customer_label": "Customer",
    "reports.amount_label": "Amount",
    "reports.type_label": "Type",
    "reports.waiter_label": "Waiter",
    "reports.product_report_title": "Product Report",
    "reports.product_report_full_desc": "View product performance: views, orders, and revenue with time filters.",
    "reports.view_label": "View",
    "reports.cart_label": "Cart",
    "reports.order_label": "Order",
    "reports.revenue_label": "Revenue",
    "reports.no_data_period": "No data in this period",
    "reports.waiter_report_title": "Waiter Report",
    "reports.waiter_report_full_desc": "View waiter performance: orders and revenue with time filters.",
    "reports.branch_comparison": "Branch Comparison",
    "reports.branch_comparison_desc": "Compare performance across all branches: orders, revenue, and resources.",
    "reports.total_branches_label": "Total Branches",
    "reports.total_products_label": "Total Products",
    "reports.main_label": "Main",
    "reports.inactive_label": "Inactive",
    "reports.revenue_card": "Revenue",
    "reports.orders_card": "Orders",
    "reports.avg_order_card": "Avg Order",
    "reports.product_label": "Product",
    "reports.category_label": "Category",
    "reports.staff_label": "Staff",
    "reports.table_label": "Table",
    "reports.active_waiter_label": "Active Waiter",
    "reports.sort_highest_amount": "Highest amount",
    "reports.sort_newest": "Newest",
    "reports.sort_oldest": "Oldest",
    "reports.sort_most_sold": "Most sold",
    "reports.sort_most_viewed": "Most viewed",
    "reports.pagination_text": "results · page {page} of {total}",
    "reports.filter_period": "Filter Period",
    "reports.refresh": "Refresh",
    "reports.total_tax": "Total Tax",
    "reports.unique_customers": "Unique Customers",
    "reports.avg_order_value": "Avg Order Value",
    "reports.completed_orders": "Completed Orders",
    "reports.pending_orders": "Pending Orders",
    "reports.cancelled_orders": "Cancelled Orders",
    "reports.refunded_orders": "Refunded Orders",
    "reports.delivery_revenue": "Delivery Revenue",
    "reports.by_source": "Sales by Source",
    "reports.revenue_trend": "Revenue Trend",
    "reports.top_products": "Top Products",
    "reports.unit": "unit",
    "reports.summary_desc": "View a comprehensive summary of all your restaurant statistics",
    "reports.cashier_report": "Cashier Report",
    "reports.order_number": "Order #",
    "reports.subtotal": "Subtotal",
    "reports.tax": "Tax",
    "reports.discount": "Discount",
    "reports.total": "Total",
    "reports.status_label": "Status",
    "reports.date_label": "Date",
    "reports.source_label": "Source",
    "reports.price_label": "Price",
    "reports.product_name": "Product",
    "reports.total_delivery_fees": "Delivery Fees",
    "reports.subtotal_before_tax": "Subtotal before {label}",
    "reports.page_of": "Page {page} of {total}",

    // Waiters extras
    "waiters.how_it_works": "How Waiter Mode Works",
    "waiters.hint_1": "Add a waiter name and a unique QR code link is generated",
    "waiters.hint_2": "When a customer scans the waiter's QR, they see a 'Dine In' option",
    "waiters.hint_3": "The waiter name is automatically recorded with each order",
    "waiters.hint_4": "No login needed — just share the waiter's QR code",
    "waiters.hint_5": "Regular customers only see delivery and pickup options",

    // Waiter Analytics
    "waiters.analytics_loading": "Loading analytics...",
    "waiters.back_to_overview": "Back to Overview",
    "waiters.performance_details": "Waiter performance details",
    "waiters.orders_label": "Orders",
    "waiters.revenue_suffix": "revenue",
    "waiters.top_products": "Top Ordered Items",
    "waiters.item_label": "Item",
    "waiters.quantity_label": "Quantity",
    "waiters.total_orders_overview": "Total Orders",
    "waiters.total_revenue_overview": "Total Revenue",
    "waiters.active_waiters_overview": "Active Waiters",
    "waiters.no_data": "No data yet",
    "waiters.no_data_hint": "Analytics will appear when waiter mode is used",
    "waiters.ranking_title": "Top Performance",
    "waiters.ranking_subtitle": "Waiters ranked by performance",
    "waiters.date_custom": "Custom",

    // Subscription page extras (new keys only)
    "subscription.payment_cancelled": "Payment was cancelled",
    "subscription.trial_activated": "Free trial activated for {days} days",
    "subscription.trial_failed": "Failed to activate free trial",
    "subscription.cancel_scheduled": "Subscription cancellation scheduled.",
    "subscription.cancel_error": "Error cancelling subscription",
    "subscription.upgrade_error": "Error calculating upgrade",
    "subscription.cannot_upgrade": "Cannot upgrade",
    "subscription.status_active": "Active",
    "subscription.status_cancelling": "Will cancel at end",
    "subscription.status_expired": "Expired",
    "subscription.status_cancelled": "Cancelled",
    "subscription.ended_at": "Ended on",
    "subscription.remaining": "remaining",
    "subscription.days": "days",
    "subscription.undefined": "Not defined",
    "subscription.expiring_soon": "Your subscription is about to expire! Renew now to avoid service interruption.",
    "subscription.suspended_title": "Subscription Suspended",
    "subscription.suspended_desc": "Your subscription has been suspended, please contact support",
    "subscription.expired_title": "Subscription Expired",
    "subscription.expired_desc": "Your subscription has expired, please renew to continue",
    "subscription.trial_ends": "Ends on",

    // Plan CTA extras
    "plan.current_plan": "Your Current Plan",
    "plan.most_popular": "Most Popular",
    "plan.lifetime_badge": "Lifetime",
    "plan.free_label": "Free",
    "plan.monthly_label": "Monthly",
    "plan.yearly_label": "Yearly",
    "plan.save_pct": "Save",
    "plan.subscribe_now": "Subscribe Now",
    "plan.upgrade_now": "Upgrade Now",
    "plan.try_free": "Try Free",
    "plan.try_free_days": "Try Free for {days} days",
    "plan.not_available": "Not Available",
    "plan.contact_support_downgrade": "Contact support to downgrade",
    "plan.compare_plans_title": "Compare Plans",
    "plan.discount_label": "Discount",
    "plan.bonus_months_label": "free months",
    "plan.bonus_month_label": "month",
    "plan.bonus_2months_label": "months",
    "plan.offer_ends_label": "Ends:",

    // Categories page (non-duplicate keys)
    "category.title": "Categories",
    "category.subtitle": "Manage menu categories",
    "category.new": "New Category",
    "category.edit": "Edit Category",
    "category.add_new": "Add New Category",
    "category.name_label": "Category Name",
    "category.name_placeholder": "e.g. Hot Beverages",
    "category.desc_placeholder": "Short category description...",
    "category.list_title": "Categories List",
    "category.no_categories": "No categories found",
    "category.scheduled": "Scheduled",
    "category.product_count": "product",
    "category.schedule": "Schedule Category",
    "category.upgrade_scheduling": "Upgrade to enable scheduling",
    "category.upgrade_to_add": "Upgrade to Add",
    "category.uploading_image": "Uploading image...",
    "category.load_error": "Error loading categories",
    "category.update_success": "Category updated successfully",
    "category.cannot_delete_has_products": "Cannot delete a category that has products",
    "category.delete": "Delete Category",
    "category.cannot_delete_tooltip": "Cannot delete category with products",
    "category.schedule_saved": "Category schedule saved successfully",

    // Addons page (non-duplicate keys only)
    "addon.title": "Add-on Groups",
    "addon.subtitle": "Manage add-on groups and their options",
    "addon.new_group": "New Group",
    "addon.edit_group": "Edit Group",
    "addon.group_name": "Group Name",
    "addon.group_name_placeholder": "e.g. Size",
    "addon.selection_type": "Selection Type",
    "addon.single_example": "e.g. Size",
    "addon.multi_select_short": "Multiple",
    "addon.multi_example": "e.g. Add-ons",
    "addon.required_desc": "Customer must make a selection",
    "addon.max_selections": "Max Selections (optional)",
    "addon.no_limit": "No limit",
    "addon.edit_addon": "Edit Add-on",
    "addon.addon_name": "Add-on Name",
    "addon.addon_name_placeholder": "e.g. Extra Cheese",
    "addon.extra_price": "Extra Price",
    "addon.no_groups": "No add-on groups",
    "addon.no_groups_hint": 'Create an add-on group like "Size" or "Sauces" then add options inside it',
    "addon.option_count": "option",
    "addon.no_options": "No options in this group",
    "addon.load_error": "Error loading data",
    "addon.group_updated": "Group updated successfully",
    "addon.group_added": "Group added successfully",
    "addon.group_save_error": "Error saving group",
    "addon.delete_group_confirm": "Are you sure you want to delete this group and all its add-ons?",
    "addon.group_deleted": "Group deleted successfully",
    "addon.group_delete_error": "Error deleting group",
    "addon.updated": "Add-on updated successfully",
    "addon.added": "Add-on added successfully",
    "addon.save_error": "Error saving add-on",
    "addon.delete_confirm": "Are you sure you want to delete this add-on?",
    "addon.deleted": "Add-on deleted successfully",
    "addon.delete_error": "Error deleting add-on",
    "addon.toggle_error": "Error updating status",

    // Sidebar keys
    "sidebar.restaurant_management": "Restaurant Management",
    "sidebar.dashboard": "Dashboard",
    "sidebar.menu_management": "Menu Management",
    "sidebar.restaurant_info": "Restaurant Info",
    "sidebar.menu": "Food Menu",
    "sidebar.extract_menu": "Extract Menu (AI)",
    "sidebar.trash": "Trash",
    "sidebar.operations": "Operations",
    "sidebar.restaurant_status": "Restaurant Status",
    "sidebar.orders": "Orders",
    "sidebar.delivery_settings": "Orders & Delivery",
    "sidebar.waiter_mode": "Waiter Mode",
    "sidebar.staff": "Staff",
    "sidebar.reports": "Reports",
    "sidebar.settings_group": "Settings",
    "sidebar.branches": "Branches",
    "sidebar.theme": "Theme & Colors",
    "sidebar.qr_code": "QR Code",
    "sidebar.subscription": "Subscription",
    "sidebar.settings": "Settings",
    "sidebar.quick_links": "Quick Links",
    "sidebar.view_menu": "View Menu",
    "sidebar.copy_link": "Copy Link",
    "sidebar.logout": "Log Out",
    "sidebar.menu_link_not_found": "Menu link not found",
    "sidebar.menu_link_copied": "Menu link copied",

    // Role keys
    "role.super_admin": "Platform Admin",
    "role.restaurant_admin": "Restaurant Admin",
    "role.cashier": "Cashier",
    "role.kitchen": "Kitchen",
    "role.waiter": "Waiter",

    // Document titles
    "overview.page_title": "Dashboard",
    "settings.page_title": "Settings",
    "staff.page_title": "Staff",
    "info.page_title": "Restaurant Info",
    "info.title": "Restaurant Info",
    "info.subtitle": "Manage basic restaurant data and images",
    "info.restaurant_data": "Restaurant Data",
    "info.shared_data": "This data is shared across all branches",
    "info.shared_across_branches": "This data is shared across all branches",
    "info.restaurant_name": "Restaurant Name",
    "info.restaurant_name_en": "Restaurant Name (English)",
    "info.country_flag": "Country flag on logo",
    "info.flag_hint": "Appears as a circular badge on the logo in the public menu - shared across all branches.",
    "info.logo": "Menu Logo Image",
    "info.logo_hint": "Supported formats: JPG, PNG. A square image is preferred.",
    "info.cover": "Menu Cover Image",
    "info.preview": "Preview:",
    "info.menu_languages": "Menu Languages",
    "info.menu_languages_desc": "Choose the languages to enable on the public menu",
    "info.arabic_only": "Arabic only",
    "info.english_only": "English only",
    "info.both_languages": "Arabic + English",
    "info.branch_data": "Branch Data",
    "info.branch_data_desc": "This data is specific to the current branch and changes when switching branches",
    "info.currency": "Currency",
    "info.branch_address": "Branch Address",
    "info.branch_address_en": "Branch Address (English)",
    "info.phone": "Phone Number",
    "info.tax_settings": "Tax Settings",
    "info.tax_settings_desc": "Tax settings for the current branch",
    "info.enable_tax": "Enable Tax",
    "info.tax_label": "Tax Label",
    "info.tax_label_hint": "Custom name displayed instead of \"Tax\" (e.g. Service Charge, VAT). Leave empty for default.",
    "info.tax_label_en": "Tax Label (English)",
    "info.tax_label_en_hint": "Displayed in the public menu when English is selected. Leave empty for default.",
    "info.tax_rate": "Tax Rate (%)",
    "info.tax_type": "Tax Type",
    "info.tax_exclusive": "Exclusive (added to price)",
    "info.tax_inclusive": "Inclusive (included in price)",
    "info.tax_type_hint": "Exclusive: tax added on top. Inclusive: tax already in the price.",
    "info.tax_order_types": "Apply to Order Types",
    "info.tax_order_types_hint": "Tax will only be applied to selected order types.",
    "info.saved": "Info saved successfully",

    // Cashier Mode
    "cashier.title": "Cashier Mode",
    "cashier.categories": "Categories",
    "cashier.current_order": "Current Order",
    "cashier.clear": "Clear",
    "cashier.empty_order": "Add items to start",
    "cashier.no_products": "No products",
    "cashier.add_discount": "Add Discount",
    "cashier.subtotal": "Subtotal",
    "cashier.discount": "Discount",
    "cashier.tax": "Tax",
    "cashier.complete_payment": "Complete Payment",
    "cashier.confirm_payment": "Confirm Payment",
    "cashier.payment_success": "Payment Successful",
    "cashier.new_order": "New Order",
    "cashier.print_receipt": "Print Receipt",
    "cashier.cash": "Cash",
    "cashier.card": "Card",
    "cashier.mixed": "Mixed",
    "cashier.paid_amount": "Paid Amount",
    "cashier.change": "Change",
    "cashier.open_shift": "Open Shift",
    "cashier.close_shift": "Close Shift",
    "cashier.start_shift": "Start Shift",
    "cashier.opening_balance": "Opening Balance",
    "cashier.closing_balance": "Actual Cash in Drawer",
    "cashier.expected_cash": "Expected Cash in Drawer",
    "cashier.total_cash": "Cash",
    "cashier.total_card": "Card",
    "cashier.total_mixed": "Mixed",
    "cashier.orders_count": "Orders",
    "cashier.search": "Search products...",
    "cashier.exit": "Exit",
    "cashier.tabs.sales": "Sales",
    "cashier.tabs.orders": "Cashier Orders",
    "cashier.tabs.reports": "Reports",
    "cashier.order_number": "Order #",
    "cashier.payment_method": "Payment",
    "cashier.order_type": "Type",
    "cashier.dine_in": "Dine In",
    "cashier.takeaway": "Takeaway",
    "cashier.refund": "Refund",
    "cashier.cancel_order": "Cancel",
    "cashier.order_details": "Order Details",
    "cashier.filter_by_cashier": "Filter by Cashier",
    "cashier.current_session_only": "Current Session",
    "cashier.all_sessions": "All Sessions",
    "cashier.no_orders": "No orders found",
    "cashier.reprint": "Reprint",
    "cashier.order_date": "Date",
    "cashier.cashier_name": "Cashier",
    "plan.feature.has_cashier_mode": "Cashier Mode",
    "plan.feature.has_cashier_mode_desc": "Fast POS interface for managing orders and payments",
    "sidebar.cashier": "Cashier Mode",

    // Dashboard (extra keys)
    "dashboard.view_all": "View All",
    "dashboard.no_orders": "No orders yet",
    "dashboard.customer": "Customer",
    "dashboard.add_product": "Add Product",
    "dashboard.view_orders": "View Orders",
    "dashboard.open_menu": "Open Menu",
    "dashboard.share_qr": "Share QR",

    // Delivery
    "delivery.free_delivery_note": "Original delivery prices are saved and will be restored when free delivery is disabled",

    // SEO
    "settings.seo_entity_menu": "Menu",

    // Orders - missing keys
    "orders.refunded": "Refunded",
    "orders.type.takeaway": "Takeaway",
    "orders.type.cashier": "Cashier",
    "orders.order_label": "Order",
    "orders.see_more": "See More",
    "orders.payment_info": "Payment Info",
    "orders.payment_method": "Payment Method",
    "orders.paid_amount": "Paid Amount",
    "orders.change_amount": "Change",
    "orders.discount": "Discount",
    "orders.tax": "Tax",
    "orders.delivery_revenue": "Delivery Revenue",

    // Forgot Password
    "forgot.title": "Forgot Password",
    "forgot.subtitle": "Enter your email to reset your password",
    "forgot.email": "Email",
    "forgot.submit": "Send Reset Link",
    "forgot.loading": "Sending...",
    "forgot.back_login": "Back to Login",
    "forgot.success_title": "Email Sent Successfully",
    "forgot.success_desc": "Check your email and follow the link to reset your password",
    "forgot.success_subtitle": "Reset link has been sent",
    "forgot.error": "An error occurred while sending the email",
    "login.showcase": "Explore Demo System",
  },
  ar: {
    // Trash
    "trash.title": "سلة المحذوفات",
    "trash.subtitle": "العناصر المحذوفة ستُزال نهائياً بعد 14 يوم",
    "trash.products": "المنتجات",
    "trash.categories": "الأقسام",
    "trash.restore": "استعادة",
    "trash.delete_forever": "حذف نهائي",
    "trash.empty_trash": "إفراغ السلة",
    "trash.no_items": "سلة المحذوفات فارغة",
    "trash.no_items_hint": "العناصر المحذوفة ستظهر هنا",
    "trash.deleted_at": "حُذف في",
    "trash.expires_in": "ينتهي خلال",
    "trash.days": "يوم",
    "trash.will_delete_soon": "سيتم حذفه قريباً",
    "trash.permanently_after": "سيُحذف نهائياً بعد",
    "trash.deleted_products": "المنتجات المحذوفة",
    "trash.deleted_categories": "الأقسام المحذوفة",
    "trash.no_products": "لا توجد منتجات محذوفة",
    "trash.no_categories": "لا توجد أقسام محذوفة",
    "trash.restore_product_success": "تم استعادة المنتج بنجاح",
    "trash.restore_category_success": "تم استعادة القسم بنجاح",
    "trash.delete_product_success": "تم حذف المنتج نهائياً",
    "trash.delete_category_success": "تم حذف القسم نهائياً",
    "trash.empty_success": "تم إفراغ سلة المحذوفات",
    "trash.confirm_title": "تأكيد الحذف",
    "trash.confirm_desc": "هذا الإجراء لا يمكن التراجع عنه.",
    "trash.uncategorized": "بدون تصنيف",

    // Delivery
    "delivery.title": "إعدادات الطلبات والتوصيل",
    "delivery.subtitle": "إدارة أنواع الطلبات ومناطق التوصيل",
    "delivery.zones": "مناطق التوصيل",
    "delivery.add_zone": "إضافة منطقة",
    "delivery.edit_zone": "تعديل المنطقة",
    "delivery.zone_name": "اسم المنطقة",
    "delivery.zone_name_en": "اسم المنطقة (إنجليزي)",
    "delivery.minimum_order": "الحد الأدنى للطلب",
    "delivery.estimated_time": "الوقت المتوقع",
    "delivery.free_delivery": "توصيل مجاني",
    "delivery.free_delivery_desc": "تفعيل التوصيل المجاني لجميع المناطق",
    "delivery.free_delivery_min": "الحد الأدنى للتوصيل المجاني",
    "delivery.order_types": "أنواع الطلبات",
    "delivery.type_delivery": "توصيل",
    "delivery.type_delivery_desc": "يمكن للعملاء طلب التوصيل إلى عنوانهم",
    "delivery.type_pickup": "استلام من الفرع",
    "delivery.type_pickup_desc": "يمكن للعملاء استلام طلباتهم من المطعم",
    "delivery.type_dine_in": "أكل في المطعم (وضع النادل)",
    "delivery.type_dine_in_desc": "طلبات عبر روابط النُدُل داخل المطعم",
    "delivery.enable_orders": "الطلبات مفعّلة",
    "delivery.view_only": "وضع العرض فقط",
    "delivery.orders_enabled_desc": "استقبال وإدارة طلبات العملاء من المنيو",
    "delivery.view_only_desc": "المنيو للعرض فقط، الطلب معطّل",
    "delivery.order_settings": "إعدادات الطلبات",
    "delivery.order_settings_desc": "التحكم في أنواع الطلبات المتاحة في المنيو",
    "delivery.zone_list": "قائمة المناطق",
    "delivery.no_zones": "لا توجد مناطق توصيل",
    "delivery.no_zones_hint": "أضف منطقة توصيل لتفعيل خدمة التوصيل",
    "delivery.fee": "رسوم التوصيل",
    "delivery.min_order": "الحد الأدنى",
    "delivery.time": "الوقت المتوقع",
    "delivery.add_success": "تم إضافة المنطقة بنجاح",
    "delivery.update_success": "تم تحديث المنطقة بنجاح",
    "delivery.delete_success": "تم حذف المنطقة بنجاح",
    "delivery.delete_confirm": "هل أنت متأكد من حذف هذه المنطقة؟",
    "delivery.settings_updated": "تم تحديث الإعدادات بنجاح",
    "delivery.free_delivery_enabled": "تم تفعيل التوصيل المجاني",
    "delivery.free_delivery_disabled": "تم تعطيل التوصيل المجاني",
    "delivery.free_delivery_min_updated": "تم تحديث الحد الأدنى للتوصيل المجاني",
    "delivery.free_delivery_max_discount": "الحد الأقصى لخصم التوصيل",
    "delivery.upgrade_needed": "غير متاح في باقتك الحالية - قم بالترقية لتفعيل هذه الميزة",
    "delivery.locked_feature": "ميزة مقفلة",
    "delivery.upgrade_plan": "ترقية",
    "delivery.time_placeholder": "مثال: 30-45 دقيقة",
    "delivery.zone_placeholder": "مثال: وسط المدينة",

    // Waiters
    "waiters.title": "النُدُل",
    "waiters.subtitle": "إدارة النُدُل وروابط الطلبات الداخلية",
    "waiters.add_new": "إضافة نادل",
    "waiters.edit": "تعديل النادل",
    "waiters.name": "اسم النادل",
    "waiters.code": "الرمز",
    "waiters.pin": "رمز PIN",
    "waiters.pin_hint": "رمز من 4-6 أرقام يُطلب عند فتح الرابط",
    "waiters.photo": "صورة النادل",
    "waiters.photo_optional": "صورة النادل (اختياري)",
    "waiters.active": "نشط",
    "waiters.copy_link": "نسخ الرابط",
    "waiters.link_copied": "تم نسخ رابط النادل",
    "waiters.list": "قائمة النُدُل",
    "waiters.no_waiters": "لم يتم إضافة نُدُل",
    "waiters.no_waiters_hint": "أضف نادل لإنشاء رابط طلب داخلي",
    "waiters.stats": "الإحصائيات",
    "waiters.total_orders": "إجمالي الطلبات",
    "waiters.total_revenue": "إجمالي الإيرادات",
    "waiters.active_waiters": "نشط",
    "waiters.inactive_waiters": "غير نشط",
    "waiters.top_performance": "الأفضل أداءً",
    "waiters.waiter_mode": "وضع النادل",
    "waiters.tab_waiters": "النُدُل",
    "waiters.tab_analytics": "الإحصائيات",
    "waiters.pin_enabled": "PIN مفعّل",
    "waiters.activated": "تم تفعيل النادل",
    "waiters.deactivated": "تم تعطيل النادل",
    "waiters.add_success": "تم إضافة النادل بنجاح",
    "waiters.update_success": "تم تحديث النادل بنجاح",
    "waiters.delete_success": "تم حذف النادل بنجاح",
    "waiters.delete_confirm": "هل أنت متأكد من حذف هذا النادل؟",
    "waiters.placeholder": "مثال: أحمد",
    "waiters.pin_placeholder": "مثال: 1234",
    "waiters.save_error": "خطأ في حفظ النادل",
    "waiters.load_error": "خطأ في تحميل النُدُل",

    // Branches
    "branches.title": "إدارة الفروع",
    "branches.subtitle": "إدارة فروع المطعم",
    "branches.add_new": "إضافة فرع",
    "branches.edit": "تعديل الفرع",
    "branches.name": "اسم الفرع",
    "branches.name_en": "اسم الفرع (إنجليزي)",
    "branches.name_required": "اسم الفرع مطلوب",
    "branches.slug": "الرابط المختصر",
    "branches.main": "رئيسي",
    "branches.set_main": "تعيين كرئيسي",
    "branches.delete_warning": "لا يمكن حذف الفرع الرئيسي",
    "branches.limit_reached": "تم الوصول لحد الفروع",
    "branches.upgrade_required": "يجب الترقية لإضافة فروع إضافية",
    "branches.frozen": "مجمّد",
    "branches.frozen_by_plan": "مجمّد بالباقة",
    "branches.multi_branch": "إدارة متعددة الفروع",
    "branches.upgrade_for_branches": "قم بترقية باقتك لإضافة فروع متعددة",
    "branches.upgrade_to_add": "ترقية لإضافة فروع",
    "branches.add_success": "تم إضافة الفرع بنجاح",
    "branches.update_success": "تم تحديث الفرع بنجاح",
    "branches.delete_success": "تم حذف الفرع بنجاح",
    "branches.main_set": "تم تعيين الفرع الرئيسي",
    "branches.cannot_disable_main": "لا يمكن تعطيل الفرع الرئيسي",
    "branches.city": "المدينة",
    "branches.link": "الرابط",
    "branches.image": "صورة الفرع",
    "branches.address_phone_hint": 'العنوان ورقم الجوال تتم إدارتهما من صفحة "معلومات المطعم" لكل فرع',
    "branches.saving": "جاري الحفظ...",
    "branches.save_edits": "حفظ التغييرات",
    "branches.add_branch": "إضافة فرع",
    "branches.deleting": "جاري حذف الفرع...",
    "branches.delete_confirm_title": "حذف الفرع",
    "branches.delete_confirm_desc":
      "هل أنت متأكد من حذف هذا الفرع؟ هذا الإجراء لا يمكن التراجع عنه وسيحذف جميع البيانات المرتبطة.",
    "branches.plan_allows": "باقتك تسمح بـ",
    "branches.branch_only": "فرع فقط",
    "branches.branches_only": "فروع فقط",
    "branches.frozen_branches": "فروع مجمّدة",
    "branches.frozen_branch": "فرع مجمّد",
    "branches.max_reached": "وصلت للحد الأقصى من الفروع",
    "branches.upgrade_for_more": "قم بترقية الباقة لإضافة المزيد.",
    "branches.upgrade_to_activate": "ترقية الباقة لتفعيل هذا الفرع",

    // Common
    "common.save": "حفظ",
    "common.cancel": "إلغاء",
    "common.delete": "حذف",
    "common.edit": "تعديل",
    "common.add": "إضافة",
    "common.update": "تحديث",
    "common.loading": "جاري التحميل...",
    "common.success": "تم بنجاح",
    "common.error": "خطأ",
    "common.active": "نشط",
    "common.inactive": "غير نشط",
    "common.upgrade": "ترقية",
    "common.optional": "اختياري",
    "common.copied": "تم النسخ",
    "common.save_changes": "حفظ التغييرات",
    "common.load_error": "خطأ في تحميل البيانات",
    "common.save_error": "خطأ في الحفظ",
    "common.update_error": "خطأ في التحديث",
    "common.delete_error": "خطأ في الحذف",
    "common.all": "الكل",
    "common.reset": "إعادة تعيين",

    // Cashier Mode
    "cashier.title": "وضع الكاشير",
    "cashier.categories": "الأقسام",
    "cashier.current_order": "الطلب الحالي",
    "cashier.clear": "مسح",
    "cashier.empty_order": "أضف عناصر للبدء",
    "cashier.no_products": "لا توجد منتجات",
    "cashier.add_discount": "إضافة خصم",
    "cashier.subtotal": "المجموع الفرعي",
    "cashier.discount": "الخصم",
    "cashier.tax": "الضريبة",
    "cashier.complete_payment": "إتمام الدفع",
    "cashier.confirm_payment": "تأكيد الدفع",
    "cashier.payment_success": "تم الدفع بنجاح",
    "cashier.new_order": "طلب جديد",
    "cashier.print_receipt": "طباعة الفاتورة",
    "cashier.cash": "كاش",
    "cashier.card": "بطاقة",
    "cashier.mixed": "مختلط",
    "cashier.paid_amount": "المبلغ المدفوع",
    "cashier.change": "الباقي",
    "cashier.open_shift": "فتح وردية",
    "cashier.close_shift": "إغلاق الوردية",
    "cashier.start_shift": "بدء الوردية",
    "cashier.opening_balance": "الرصيد الافتتاحي",
    "cashier.closing_balance": "النقد الفعلي في الدرج",
    "cashier.expected_cash": "النقد المتوقع في الدرج",
    "cashier.total_cash": "كاش",
    "cashier.total_card": "بطاقة",
    "cashier.total_mixed": "مختلط",
    "cashier.orders_count": "الطلبات",
    "cashier.search": "بحث عن منتج...",
    "cashier.exit": "خروج",
    "cashier.tabs.sales": "المبيعات",
    "cashier.tabs.orders": "طلبات الكاشير",
    "cashier.tabs.reports": "التقارير",
    "cashier.order_number": "رقم الطلب",
    "cashier.payment_method": "طريقة الدفع",
    "cashier.order_type": "نوع الطلب",
    "cashier.dine_in": "داخل المطعم",
    "cashier.takeaway": "خارج المطعم",
    "cashier.refund": "استرجاع",
    "cashier.cancel_order": "إلغاء الطلب",
    "cashier.order_details": "تفاصيل الطلب",
    "cashier.filter_by_cashier": "فلترة حسب الكاشير",
    "cashier.current_session_only": "الجلسة الحالية",
    "cashier.all_sessions": "جميع الجلسات",
    "cashier.no_orders": "لا توجد طلبات",
    "cashier.reprint": "إعادة طباعة",
    "cashier.order_date": "التاريخ",
    "cashier.cashier_name": "الكاشير",
    "plan.feature.has_cashier_mode": "وضع الكاشير",
    "plan.feature.has_cashier_mode_desc": "واجهة نقطة بيع سريعة لإدارة الطلبات والمدفوعات",
    "sidebar.cashier": "وضع الكاشير",

    // Dashboard
    "dashboard.recent_orders": "آخر الطلبات",
    "dashboard.view_all": "عرض الكل",
    "dashboard.no_orders": "لا توجد طلبات بعد",
    "dashboard.customer": "عميل",
    "dashboard.add_product": "إضافة منتج",
    "dashboard.view_orders": "عرض الطلبات",
    "dashboard.open_menu": "فتح المنيو",
    "dashboard.share_qr": "مشاركة QR",

    // Categories form
    "category.name_ar": "اسم القسم (عربي)",
    "category.desc_ar": "الوصف (عربي)",

    // Delivery
    "delivery.free_delivery_note": "أسعار التوصيل الأصلية محفوظة وستعود عند إلغاء التوصيل المجاني",

    // SEO
    "settings.seo_entity_menu": "المنيو",

    // Orders - source filters
    "orders.source.pickup": "استلام",
    "orders.source.delivery": "توصيل",
    "orders.source.waiter": "ويتر",
    "orders.source.cashier": "كاشير",
    "orders.edit_items": "تعديل أصناف الطلب",
    "orders.notify_cashier": "إبلاغ الكاشير",
    "orders.notify_cashier_title": "إبلاغ الكاشير – طلب #",
    "orders.notify_cashier_desc": "صف المشكلة في هذا الطلب. سيظهر تنبيه للكاشير.",
    "orders.notify_cashier_placeholder": "مثال: العميل يريد إلغاء الطلب...",

    // Orders - missing keys
    "orders.refunded": "مسترجع",
    "orders.type.takeaway": "خارج المحل",
    "orders.type.cashier": "الكاشير",
    "orders.order_label": "الطلب",
    "orders.see_more": "عرض المزيد",
    "orders.payment_info": "معلومات الدفع",
    "orders.payment_method": "طريقة الدفع",
    "orders.paid_amount": "المبلغ المدفوع",
    "orders.change_amount": "الباقي",
    "orders.discount": "الخصم",
    "orders.tax": "الضريبة",
    "orders.delivery_revenue": "إيرادات التوصيل",

    // Delivery - free delivery notes
    "delivery.free_min_note": "Free delivery for orders of {amount} or more",
    "delivery.free_all_note": "Free delivery for all orders with no minimum",
    "delivery.max_discount_note": "Delivery discount up to {amount} – e.g. delivery {currency}20 becomes {currency}{result}",
    "delivery.max_discount_unlimited": "Completely free delivery with no maximum discount",
    "delivery.original_prices_note": "Prices shown are original – delivery is currently free for customers",

    // Reports
    "reports.subtotal_before_tax": "المجموع قبل {label}",
    "reports.page_of": "صفحة {page} من {total}",
    "reports.filter_period": "فلترة الفترة",
    "reports.refresh": "تحديث",
    "reports.total_tax": "الضريبة المحصّلة",
    "reports.unique_customers": "عملاء فريدون",
    "reports.avg_order_value": "متوسط الطلب",
    "reports.completed_orders": "طلبات مكتملة",
    "reports.pending_orders": "طلبات معلّقة",
    "reports.cancelled_orders": "طلبات ملغية",
    "reports.refunded_orders": "طلبات مسترجعة",
    "reports.delivery_revenue": "إيرادات التوصيل",
    "reports.by_source": "المبيعات حسب المصدر",
    "reports.revenue_trend": "اتجاه الإيرادات",
    "reports.top_products": "أفضل المنتجات",
    "reports.unit": "وحدة",
    "reports.summary_desc": "عرض ملخص شامل لجميع إحصائيات مطعمك",
    "reports.cashier_report": "تقرير الكاشير",
    "reports.order_number": "رقم الطلب",
    "reports.subtotal": "المجموع الفرعي",
    "reports.tax": "الضريبة",
    "reports.discount": "الخصم",
    "reports.total": "الإجمالي",
    "reports.status_label": "الحالة",
    "reports.date_label": "التاريخ",
    "reports.source_label": "المصدر",
    "reports.price_label": "السعر",
    "reports.product_name": "الصنف",
    "reports.total_delivery_fees": "رسوم التوصيل",
    "reports.branch_comparison": "مقارنة الفروع",
    "reports.branch_comparison_desc": "مقارنة شاملة بين أداء جميع الفروع من حيث الطلبات والإيرادات والموارد.",
    "reports.total_branches_label": "إجمالي الفروع",
    "reports.total_products_label": "إجمالي المنتجات",
    "reports.main_label": "رئيسي",
    "reports.inactive_label": "غير نشط",
    "reports.revenue_card": "الإيرادات",
    "reports.orders_card": "الطلبات",
    "reports.avg_order_card": "متوسط الطلب",
    "reports.product_label": "منتج",
    "reports.category_label": "قسم",
    "reports.staff_label": "موظف",
    "reports.table_label": "طاولة",
    "reports.active_waiter_label": "نادل نشط",
    "reports.sort_highest_amount": "الأعلى مبلغاً",
    "reports.sort_newest": "الأحدث",
    "reports.sort_oldest": "الأقدم",
    "reports.total_orders_summary": "إجمالي الطلبات",
    "reports.total_revenue_summary": "إجمالي الإيرادات",
    "reports.by_status_label": "حسب الحالة",
    "reports.by_type_label": "حسب النوع",
    "reports.no_orders_in_period": "لا توجد طلبات في هذه الفترة",
    "reports.customer_label": "العميل",
    "reports.amount_label": "الإجمالي",
    "reports.type_label": "النوع",
    "reports.waiter_label": "النادل",
    "reports.order_count_label": "طلب",
    "reports.phone_label": "الهاتف",
    "reports.total_spent_card": "إجمالي المصروف",
    "reports.address_label": "العنوان",
    "reports.order_report_full_desc": "عرض جميع الطلبات مع تفاصيلها وإحصائيات إجمالية مع دعم الفلترة الزمنية.",
    "reports.product_report_full_desc": "عرض أداء كل صنف من حيث المشاهدات والطلبات والإيرادات مع فلترة زمنية.",
    "reports.waiter_report_full_desc": "عرض أداء كل نادل من حيث عدد الطلبات والإيرادات مع فلترة زمنية.",
    "reports.cart_label": "سلة",
    "reports.order_label": "طلب",
    "reports.revenue_label": "إيرادات",
    "reports.no_data_period": "لا توجد بيانات في هذه الفترة",
    "reports.no_data": "لا توجد بيانات",

    // Staff permissions
    "staff.dashboard": "Dashboard",
    "staff.restaurant_info": "Restaurant Info",
    "staff.menu_trash": "Menu & Trash",
    "staff.status_orders": "Status & Orders",
    "staff.delivery_settings": "Orders & Delivery Settings",
    "staff.waiter_mode": "Waiter Mode",
    "staff.cashier_mode": "Cashier Mode",
    "staff.employees": "Employees",
    "staff.reports": "Reports",
    "staff.theme": "Theme & Colors",
    "staff.branches": "Branches",
    "staff.section_general": "General",
    "staff.section_menu": "Menu Management",
    "staff.section_operations": "Operations",
    "staff.section_settings": "Settings",
    "staff.cashier_permissions": "Additional Cashier Permissions",
    "staff.can_refund_orders": "Allow order refunds",

    // Theme
    "theme.dark_mode": "Dark Mode",
    "theme.dark_mode_desc": "Allow customers to enable dark mode in the menu",

    // Forgot Password
    "forgot.title": "نسيت كلمة المرور",
    "forgot.subtitle": "أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور",
    "forgot.email": "البريد الإلكتروني",
    "forgot.submit": "إرسال رابط إعادة التعيين",
    "forgot.loading": "جاري الإرسال...",
    "forgot.back_login": "العودة لتسجيل الدخول",
    "forgot.success_title": "تم إرسال البريد بنجاح",
    "forgot.success_desc": "تحقق من بريدك الإلكتروني واتبع الرابط لإعادة تعيين كلمة المرور",
    "forgot.success_subtitle": "تم إرسال رابط إعادة تعيين كلمة المرور",
    "forgot.error": "حدث خطأ أثناء إرسال البريد",
    "login.showcase": "استعراض النظام التجريبي",
  },
};
